import { Link } from "react-router-dom";
import { Instagram, Linkedin, Mail, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#1C1C1C] text-white" data-testid="footer">
      {/* Big CTA */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-24 pb-16">
        <div className="mb-20">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-white/40 mb-6">
            Got a project in mind?
          </p>
          <Link to="/contact" className="group inline-block">
            <h2 className="text-4xl md:text-7xl font-black tracking-tight text-white group-hover:text-[#FF5E3A] transition-colors duration-300">
              Let's make something<br />
              <em className="not-italic text-[#FF5E3A] group-hover:text-white transition-colors duration-300">good.</em>
            </h2>
          </Link>
        </div>

        <div className="border-t border-white/10 pt-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div>
              <span className="text-xl font-black tracking-tight uppercase block mb-6">
                Create Motion
              </span>
              <p className="text-white/50 text-sm leading-relaxed max-w-xs">
                Motion graphics, animation, video editing and creative services for brands and agencies.
              </p>
            </div>

            <div>
              <p className="text-xs uppercase tracking-[0.2em] font-semibold text-white/40 mb-6">
                Pages
              </p>
              <ul className="space-y-3">
                {["Work", "Services", "About", "Contact"].map((item) => {
                  const path = item === "Work" ? "/portfolio" : item === "Services" ? "/prices" : `/${item.toLowerCase()}`;
                  return (
                    <li key={item}>
                      <Link
                        to={path}
                        className="text-white/70 hover:text-[#FF5E3A] transition-colors font-medium text-sm flex items-center gap-1"
                        data-testid={`footer-link-${item.toLowerCase()}`}
                      >
                        {item}
                        <ArrowUpRight size={12} />
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div>
              <p className="text-xs uppercase tracking-[0.2em] font-semibold text-white/40 mb-6">
                Get in Touch
              </p>
              <ul className="space-y-3 mb-8">
                <li>
                  <a href="mailto:elliotshaw92@gmail.com" className="text-[#FF5E3A] hover:text-white transition-colors text-sm font-medium" data-testid="footer-email">
                    elliotshaw92@gmail.com
                  </a>
                </li>
                <li>
                  <a href="tel:07487510819" className="text-[#FF5E3A] hover:text-white transition-colors text-sm font-medium" data-testid="footer-phone">
                    07487 510819
                  </a>
                </li>
              </ul>
              <div className="flex gap-3">
                <a href="https://www.instagram.com/elljshaw/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:bg-[#FF5E3A] hover:border-[#FF5E3A] hover:text-white transition-all" data-testid="footer-instagram">
                  <Instagram size={16} />
                </a>
                <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:bg-[#FF5E3A] hover:border-[#FF5E3A] hover:text-white transition-all" data-testid="footer-linkedin">
                  <Linkedin size={16} />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 text-center">
          <p className="text-white/30 text-xs">
            © {new Date().getFullYear()} Create Motion — Elliot Shaw. Formby, Merseyside.
          </p>
        </div>
      </div>
    </footer>
  );
}
